import { connect } from 'react-redux';
import { compose, withHandlers, withProps, withState } from 'recompose';
import { blur, change, Field, focus } from 'redux-form';
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import SimpleCurrencyInput from './SimpleCurrency';
import { SHOP_CURRENCY } from '../main/shops/constants';
import { INDETERMINATE } from './constants';
import withOverridableCurrency from './hoc/withOverridableCurrency';

const FieldComponent = props => (
  <div className="u-position-relative">
    <div className="c-prefix" display-if={props.showPrefix}>{props.prefix}</div>
    <div className="c-input-with-indeterminate">
      <div
        className={classnames(
          'indeterminate-label',
          props.className,
          { 'c-input--prepend': props.showPrefix, 'indeterminate-label__hidden': !props.showVaries }
        )}
        onClick={props.handleVariesClick}
      >
        Varies
      </div>
      <SimpleCurrencyInput
        precision={props.precision}
        onInputChange={(value) => {
          if (value !== props.input.value) {
            props.input.onChange(value);
          }
        }}
        value={props.input.value === INDETERMINATE ? '' : props.input.value}
        className={classnames('input-field', props.className, { 'c-input--prepend': props.showPrefix })}
        placeholder={props.placeholder}
        onInputBlur={() => props.input.onBlur(props.input.value)}
        onInputFocus={props.input.onFocus}
        separator={props.separator}
        name={props.input.name}
        disabled={props.disabled}
      />
    </div>
    {props.meta.touched && props.meta.error &&
    <div className="c-input-error-message">{props.meta.error}</div>}
  </div>
);

FieldComponent.propTypes = {
  name: PropTypes.string.isRequired,
  prefix: PropTypes.string,
  showPrefix: PropTypes.bool,
  meta: PropTypes.object.isRequired,
  input: PropTypes.object.isRequired,
  separator: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  showVaries: PropTypes.bool.isRequired,
  handleVariesClick: PropTypes.func.isRequired,
  precision: PropTypes.number.isRequired,
};

FieldComponent.defaultProps = {
  className: '',
  placeholder: '',
  disabled: false,
  prefix: '',
  showPrefix: true,
};


const IntermediateCurrencyInputContainer = compose(
  connect(null, { focus, change, blur }),
  withState('showVaries', 'setShowVaries', props => props.input.value === INDETERMINATE),
  withHandlers({
    handleVariesClick: props => () => {
      props.setShowVaries(false);
      document.querySelector(`input[name="${props.input.name}"]`)
        .focus();
    },
    onBlur: props => () => {
      if (props.input.value === INDETERMINATE || (props.input.value === '' && props.meta.initial === INDETERMINATE)) {
        props.setShowVaries(true);
        // We intercept blur so we can send INDETERMINATE
        props.blur(props.meta.form, props.input.name, INDETERMINATE);
      }
    },
  }),
  withProps(props => ({
    input: {
      ...props.input,
      onBlur: props.onBlur,
    },
  }))
)(FieldComponent);

const IndeterminateCurrencyInput = ({ name, integer, ...attributes }) => {
  let props = attributes;
  if (integer) {
    props = {
      ...attributes,
      format: val => val / 100,
      parse: val => val * 100,
      precision: 0,
      separator: '',
    };
  }

  if (!props.prefix) {
    props.prefix = props.currencySymbol;
  }

  return (
    <Field
      name={name}
      component={IntermediateCurrencyInputContainer}
      {...props}
    />
  );
};

IndeterminateCurrencyInput.propTypes = {
  name: PropTypes.string.isRequired,
  currency: PropTypes.string,
  currencySymbol: PropTypes.string,
  integer: PropTypes.bool,
  prefix: PropTypes.string,
  showPrefix: PropTypes.bool,
};

IndeterminateCurrencyInput.defaultProps = {
  currency: SHOP_CURRENCY.usd,
  currencySymbol: '$',
  integer: false,
  prefix: '',
  showPrefix: true,
};

export default withOverridableCurrency(IndeterminateCurrencyInput);
